module.exports = __webpack_public_path__ + "img/Close.22c99a61.svg";